<template>
  <div class="recipe-detail">
    <!--<RecipeHeader
      :title="recipe.title"
      @back="handleBack"
      @share="handleShare"
    />-->

    <RecipeHero
      :image="recipe.imageUrl"
      :title="recipe.title"
      :author="recipe.author"
    />

    <RecipeTabs
      :sections="sections"
      :active-section="activeSection"
      @tab-change="handleTabChange"
    />
    <div class="user-section">
      <img :src="recipe.userIcon" alt="用戶頭像" class="avatar" />
      <div class="user-info">
        <h3>{{ recipe.username }}</h3>
        <p>{{ recipe.likeCount }} collected</p>
      </div>
      <div class="recipe-data">
        <div class="recipe-data-item">
          <i class="fa-solid fa-clock"></i>&nbsp;<span
            >{{ recipe.prepTime }}分鐘</span
          >
        </div>
        <div class="recipe-data-item">
          <i class="fa-solid fa-fork-knife"></i>&nbsp;<span>
            {{ difficultyStr(recipe.difficulty) }}</span
          >
        </div>
      </div>
    </div>
    <div class="serving-section">{{ recipe.servings }} servings</div>
    <section id="intro" class="section">
      <RecipeSection title="關於這道菜">
        <p class="description">{{ recipe.description }}</p>

        <template #extra>
          <div class="section-title" style="margin-top: 24px">
            <div class="section-icon"></div>
            <h2>食譜標籤</h2>
          </div>
          <div class="tags">
            <span v-for="tag in recipe.tags" :key="tag" class="tag">{{
              tag
            }}</span>
          </div>

          <div class="section-title">
            <div class="section-icon"></div>
            <h2>營養資訊 (每份)</h2>
          </div>
          <div class="nutrition-grid">
            <div class="nutrition-item">
              <i class="nutrition-icon"></i>
              <div class="nutrition-title">calories</div>
              <div>{{ recipe.cnutrition.calories }} cal</div>
            </div>
            <div class="nutrition-item">
              <i class="nutrition-icon"></i>
              <div class="nutrition-title">protein</div>
              <div>
                {{
                  recipe.cnutrition.nutrition &&
                  recipe.cnutrition.nutrition.protein
                }}
                g
              </div>
            </div>
            <div class="nutrition-item">
              <i class="nutrition-icon"></i>
              <div class="nutrition-title">fat</div>
              <div>
                {{
                  recipe.cnutrition.nutrition && recipe.cnutrition.nutrition.fat
                }}
                g
              </div>
            </div>
            <div class="nutrition-item">
              <i class="nutrition-icon"></i>
              <div class="nutrition-title">carbs</div>
              <div>
                {{
                  recipe.cnutrition.nutrition &&
                  recipe.cnutrition.nutrition.carbs
                }}
                g
              </div>
            </div>
            <div class="nutrition-item">
              <i class="nutrition-icon"></i>
              <div class="nutrition-title">fiber</div>
              <div>
                {{
                  recipe.cnutrition.nutrition &&
                  recipe.cnutrition.nutrition.fiber
                }}
                g
              </div>
            </div>
          </div>
        </template>
      </RecipeSection>
    </section>

    <section id="ingredients" class="section">
      <RecipeSection title="所需食材">
        <ul class="ingredient-list">
          <li
            v-for="ingredient in recipe.ingredients"
            :key="ingredient.name"
            class="ingredient-item"
          >
            <i class="fas fa-check-circle" style="color: var(--primary)"></i>
            <div class="ingredient-title">{{ ingredient.name }}</div>
            <div>{{ ingredient.quantity }}</div>
          </li>
        </ul>
      </RecipeSection>
    </section>

    <section id="steps" class="section">
      <RecipeSection title="製作步驟">
        <ol class="step-list">
          <li
            v-for="(step, index) in recipe.steps"
            :key="index"
            class="step-item"
          >
            <div class="step-number">{{ index + 1 }}</div>
            <div>
              <p>{{ step.instruction }}</p>
              <img
                v-if="step.image"
                :src="step.image"
                :alt="'步驟 ' + (index + 1)"
                class="step-image"
              />
            </div>
          </li>
        </ol>
      </RecipeSection>
    </section>

    <section id="community" class="section">
      <RecipeSection title="廚友圈">
        <p>{{ recipe.postCount }}則分享</p>
        <RecipeCommunity :posts="communityPosts" />
        <button class="add-post-button" @click="handleAddPost">
          <i class="fas fa-plus"></i> 上傳我的作品
        </button>
      </RecipeSection>
    </section>

    <section id="comments" class="section">
      <RecipeSection title="評論">
        <p>{{ recipe.commentCount }}則評論</p>
        <RecipeComment
          v-for="comment in comments"
          :key="comment.id"
          :comment="comment"
        />
        <button class="add-comment-button" @click="handleAddComment">
          <i class="fas fa-plus"></i> 我要留言
        </button>
      </RecipeSection>
    </section>

    <RecipeBottomNav
      :is-liked="isLiked"
      @like="toggleLike"
      @cook="startCooking"
    />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
//import RecipeHeader from "@/components/RecipeHeader.vue";
import RecipeHero from "@/components/RecipeHero.vue";
import RecipeTabs from "@/components/RecipeTabs.vue";
import RecipeSection from "@/components/RecipeSection.vue";
import RecipeComment from "@/components/RecipeComment.vue";
import RecipeCommunity from "@/components/RecipeCommunity.vue";
import RecipeBottomNav from "@/components/RecipeBottomNav.vue";
import { useScrollProgress } from "@/composables/useScrollProgress";
import recipeApi from "../services/recipe.js";
import { useRoute } from "vue-router";
import moment from "moment";
export default {
  name: "RecipeDetail",
  components: {
    //RecipeHeader,
    RecipeHero,
    RecipeTabs,
    RecipeSection,
    RecipeComment,
    RecipeCommunity,
    RecipeBottomNav,
  },
  setup() {
    const {
      activeSection,
      progress,
      initScrollListener,
      cleanupScrollListener,
    } = useScrollProgress();
    const route = useRoute();
    const isLiked = ref(false);
    const sections = [
      { id: "intro", label: "簡介" },
      { id: "ingredients", label: "食材" },
      { id: "steps", label: "步驟" },
      { id: "community", label: "廚友圈" },
      { id: "comments", label: "評論" },
    ];
    const difficultyStr = (difficulty) => {
      switch (difficulty) {
        case 0:
          return "簡單";
        case 1:
          return "中等";
        case 2:
          return "困難";
        default:
          return "未知";
      }
    };
    const recipe = ref({
      title: "",
      description: "",
      imageUrl: "",
      username: "",
      userIcon: "",
      prepTime: 0,
      difficulty: 0,
      servings: 0,
      likeCount: 0,
      commentCount: 0,
      postCount: 0,
      isLiked: false,
      tags: [],
      ingredients: [],
      steps: [],
      cnutrition: {},
      comments: [],
    });
    const communityPosts = ref([]);
    const comments = ref([]);

    const handleTabChange = (sectionId) => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    };

    const toggleLike = () => {
      isLiked.value = !isLiked.value;
      if (isLiked.value) {
        recipe.value.likeCount++;
      } else {
        recipe.value.likeCount--;
      }
    };

    const startCooking = () => {
      console.log("開始烹飪");
      // 導航到烹飪模式頁面
    };

    const handleBack = () => {
      console.log("返回上一頁");
      // 返回邏輯
    };

    const handleShare = () => {
      console.log("分享食譜");
      // 分享邏輯
    };

    const handleAddPost = () => {
      console.log("上傳作品");
      // 上傳作品邏輯
    };

    const handleAddComment = () => {
      console.log("添加評論");
      // 添加評論邏輯
    };

    onMounted(() => {
      const recipeId = route.params.id;
      recipeApi
        .getRecipeDetails(recipeId)
        .then((resp) => {
          if (resp.success && resp.data) {
            recipe.value = { ...recipe.value, ...resp.data };
          }
        })
        .catch((error) => {
          console.error("獲取食譜詳情失敗:", error);
        });
      recipeApi
        .getCommunityPosts(recipeId)
        .then((resp) => {
          if (resp.success && resp.data) {
            communityPosts.value = resp.data;
          }
        })
        .catch((error) => {
          console.error("獲取食譜㕑友圈失敗:", error);
        });
      recipeApi
        .getComments(recipeId)
        .then((resp) => {
          if (resp.success && resp.data) {
            comments.value = resp.data;
            for (let comment of comments.value) {
              comment.publishedDateTimeString = moment(
                comment.publishedDateTime
              ).format("YYYY-MM-DD");
              for (let reply of comment.replies) {
                reply.publishedDateTimeString = moment(
                  reply.publishedDateTime
                ).format("YYYY-MM-DD");
              }
            }
          }
        })
        .catch((error) => {
          console.error("獲取食譜評論失敗:", error);
        });
      initScrollListener();
    });

    onUnmounted(() => {
      cleanupScrollListener();
    });

    return {
      recipe,
      communityPosts,
      comments,
      sections,
      activeSection,
      progress,
      isLiked,
      handleTabChange,
      toggleLike,
      startCooking,
      handleBack,
      handleShare,
      handleAddPost,
      handleAddComment,
      difficultyStr,
    };
  },
};
</script>

<style scoped></style>
